module.exports = __webpack_public_path__ + "img/icon_bg1.9aa6f63d.png";